import { render } from "./BilancioFattureFornitori.vue?vue&type=template&id=0d4b44a1"
import script from "./BilancioFattureFornitori.vue?vue&type=script&lang=js"
export * from "./BilancioFattureFornitori.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__